'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _Constants = require('../Constants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LookupRecord = function (_Record) {
  _inherits(LookupRecord, _Record);

  function LookupRecord() {
    _classCallCheck(this, LookupRecord);

    return _possibleConstructorReturn(this, (LookupRecord.__proto__ || Object.getPrototypeOf(LookupRecord)).apply(this, arguments));
  }

  _createClass(LookupRecord, [{
    key: 'isKnown',
    value: function isKnown() {
      return Object.keys(_Constants.API_KNOWN_KEY_MAPPINGS).indexOf(this.type) >= 0;
    }
  }, {
    key: 'getKnownName',
    value: function getKnownName() {
      if (!this.isKnown()) {
        return undefined;
      }

      return _Constants.API_KNOWN_KEY_MAPPINGS[this.type];
    }
  }, {
    key: 'getKnownObject',
    value: function getKnownObject() {
      var _ref;

      if (!this.isKnown()) {
        return undefined;
      }

      return _ref = {}, _defineProperty(_ref, _Constants.API_KNOWN_VALUE_MAPPINGS[this.type].primaryIdentifier, this.primaryIdentifier), _defineProperty(_ref, _Constants.API_KNOWN_VALUE_MAPPINGS[this.type].secondaryIdentifier, this.secondaryIdentifier), _defineProperty(_ref, 'fileManagerKey', this.fileManagerKey), _ref;
    }
  }, {
    key: 'getIdentifierName',
    value: function getIdentifierName() {
      return _Constants.API_IDENTIFIER_MAPPINGS[this.type];
    }
  }, {
    key: 'getIdentifier',
    value: function getIdentifier() {
      return this.primaryIdentifier;
    }
  }, {
    key: 'isSameAs',
    value: function isSameAs(lookup) {
      if (this.type === lookup.type) {
        return this.primaryIdentifier === lookup.primaryIdentifier;
      }

      var haveVid = _immutable.Set.of('contact', 'vid').has(this.type) && _immutable.Set.of('contact', 'vid').has(lookup.type);
      var haveCompanyId = _immutable.Set.of('company', 'companyId').has(this.type) && _immutable.Set.of('company', 'companyId').has(lookup.type);
      if (haveVid || haveCompanyId) {
        return this.primaryIdentifier === lookup.primaryIdentifier;
      }

      if (this.type === 'contact' && lookup.type === 'email' || this.type === 'company' && lookup.type === 'domain') {
        return this.secondaryIdentifier === lookup.primaryIdentifier;
      }

      if (this.type === 'email' && lookup.type === 'contact' || this.type === 'domain' && lookup.type === 'company') {
        return this.primaryIdentifier === lookup.secondaryIdentifier;
      }

      return false;
    }
  }, {
    key: 'requiresPortalId',
    value: function requiresPortalId() {
      return _Constants.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID.indexOf(this.type) > -1;
    }
  }]);

  return LookupRecord;
}((0, _immutable.Record)({
  type: undefined,
  primaryIdentifier: undefined,
  secondaryIdentifier: undefined,
  fileManagerKey: undefined,
  dimensions: undefined
}, 'LookupRecord'));

exports.default = LookupRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/Records/LookupRecord.js
// module id = 187
// module chunks = 177